var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "m-no-content",
    class: _vm.cardClass,
    attrs: {
      "flat": "",
      "color": _vm.color,
      "min-height": _vm.minHeight
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center",
      "no-gutters": ""
    }
  }, [!_vm.dense ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    staticClass: "mx-auto",
    attrs: {
      "color": _vm.avatarColor,
      "size": "48",
      "rounded": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "28"
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1)], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.text))])], 1)], 1)], 1), _vm.$slots.actions ? _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._t("actions")], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }